import coinInfoTable from '../widgets/coinInfoTable.js';

(function ($) {
    $(async function () {
        window.$ = jQuery;
        await coinInfoTable.updateDynamicsData();
    });
}(jQuery));